/**
 * `Н48` (баг РП, 16.10 17:3x): тело административной правки — **только поля белого
 * списка сервера**.
 *
 * Белый список живёт на сервере (`back_balance/service/user-service.js`,
 * `ADMIN_EDITABLE_USER_FIELDS`) и отказ на чужое поле — 400. Прежде сайт слал в
 * правке `role_id`, `company_id`, `plant_id`, и правка падала на поле, которого
 * форма администратора даже не показывает: причина отказа была не о том, что
 * человек сделал.
 *
 * Связи станций (`station_id`, `detach_station_ids`) в перечень не входят намеренно:
 * это не поля человека, и сервер разбирает их отдельно, до проверки белого списка.
 * Их собирает тот, кто зовёт правку, — здесь их нет.
 */

/** Зеркало серверного перечня: то, что правка вправе менять. */
export const ADMIN_EDITABLE_USER_FIELDS = [
  "email",
  "tel",
  "password",
  "firstName",
  "lastName",
  "surName",
  "img",
] as const;

/**
 * Оставить в теле правки только поля перечня. Незаполненное (`undefined`) не
 * отправляем: «не менял» и «стёр» — разные вещи, а сервер на `undefined` поля
 * наложил бы пустое значение.
 */
export function adminEditableFields(
  source: Record<string, unknown>,
): Record<string, unknown> {
  const body: Record<string, unknown> = {};

  for (const field of ADMIN_EDITABLE_USER_FIELDS) {
    const value = source[field];

    if (value === undefined) continue;

    body[field] = value;
  }

  return body;
}
